import React, { useEffect, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, resetMessage } from '../flux/actions/shoppingCart-actions';


import {
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Typography,
} from '@material-ui/core';

import soldOut from '../assets/sold_out.png';

const useStyles = makeStyles(({breakpoints}) => 
    createStyles({
        card: {
            maxWidth: 345,
            height: 620,
            margin: "auto",
            [breakpoints.down('sm')]: {
                width: 320,
                height: 540
            }
        },
        media: {
            height: 350,
            width: "100%",
            backgroundsize: "cover",
            [breakpoints.down('sm')]: {
                height: 320
            }
        },
        cardContent: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: 200,
            '& h5': {
                fontSize: '20px',
                fontWeight: 'bolder'
            },
            [breakpoints.down('sm')]: {
                height: 150
            }
        },
        priceSection: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: '10px',
            marginBottom: '10px',
            '& label': {
                color:'gray',
                fontSize: '22px'
            },
            '& span': {
                color: '#D32F2F',
                fontWeight: 'bolder',
                fontSize: '20px'
            }
        },
        soldOut: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%'
        }
    })
);

interface Props {
    _id: string;
    full_name: string;
    image: string;
    isDelete: boolean;
    cost: number;
    description: string;
    amount: number;
    hideDescription?: boolean;
    addToCartHandler: any;
}

export const ProductCard = (product: Props) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const cart = useSelector((state: any) => state.cart);

    useEffect(() => {
        dispatch(resetMessage());
    }, [dispatch]);

    return (
        <Card className={classes.card}>
            <CardActionArea>
                <Link to={`/product/${product._id}`}>
                    <CardMedia
                        className={classes.media}
                        image={product.image}
                        title={product.full_name}
                    />
                    { product.amount === 0 && <img className={classes.soldOut} src={soldOut} alt="Sold Out"/> }
                </Link>
            </CardActionArea>
            <CardContent className={classes.cardContent}>
                <Typography variant="h5" display="block" component="h5" >
                    {product.full_name}
                </Typography>
                <div className={classes.priceSection}>
                    <label>
                        Precio
                    </label>
                    <span>
                        ${product.cost ? product.cost.toFixed(2) : 0}
                    </span>
                </div>
                <Typography style={{overflowY: 'auto'}}>
                    { !product.hideDescription && product.description }
                </Typography>
            </CardContent>
            <hr/>
            <CardActions>
                { product.amount > 0 &&  
                    <Button
                        style={{marginRight: '25px', fontWeight: 'bolder'}}
                        onClick={() => product.addToCartHandler(product._id)}
                    >
                        Comprar
                    </Button>
                }
                <Button
                    style={{fontWeight: 'bolder'}}
                    color="secondary"
                    onClick={() => history.push(`/product/${product._id}`)}
                >
                    Ver
                </Button>
            </CardActions>
        </Card>
    )
};
